import { FoundingDocument } from '../../enums/foundingDocumentEnum'

export const getFoundingDocumentImageRf = (foundingDocument: string) => {
  const value = Number(foundingDocument)
  return {
    label: {
      eng:
        value === FoundingDocument.PowerOfAttorney
          ? 'Scanned copy of the Proxy*'
          : value === FoundingDocument.Charter
          ? 'Scanned copy of the Minutes or Resolution of Appointment*'
          : 'Scanned copy of the Appointment Order*',
      rus:
        value === FoundingDocument.PowerOfAttorney
          ? 'Скан-копия доверенности*'
          : value === FoundingDocument.Charter
          ? 'Скан-копия протокола или решения о назначении*'
          : 'Скан-копия приказа о назначении*',
      kz:
        value === FoundingDocument.PowerOfAttorney
          ? 'Сенімхаттың сканерленген көшірмесі*'
          : value === FoundingDocument.Charter
          ? 'Хаттаманың немесе тағайындау туралы шешімнің сканерленген көшірмесі*'
          : 'Тағайындау туралы бұйрықтың сканерленген көшірмесі*',
    },
    placeholder: {
      eng: 'Select or drag a file',
      rus: 'Выберите или перетащите файл',
      kz: 'Файлды таңдаңыз немесе сүйреңіз',
    },
    invalidText: {
      eng: 'Upload a photo',
      rus: 'Загрузите фото',
      kz: 'фотосуретін жүктеңіз',
    },
  }
}
